import { render } from "./zcfgResource.vue?vue&type=template&id=e0f7b350&scoped=true"
import script from "./zcfgResource.vue?vue&type=script&lang=js"
export * from "./zcfgResource.vue?vue&type=script&lang=js"

import "./zcfgResource.vue?vue&type=style&index=0&id=e0f7b350&lang=scss&scoped=true"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e0f7b350"]])

export default __exports__